/* eslint-disable angular/timeout-service */
import {
	ref, computed, reactive,
} from '@vue/reactivity';
import { BaseController } from '~/utils/base-controller';

import './dev-text-editor.scss';

/* globals WrapService */

// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevMfController extends BaseController {
	/** @type {WrapService.Fn} */
	$wrap;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ISCEService} $sce
	 * @param {any} $wrap
	 * @param {any} $scope
	 */
	constructor($injector, $sce, $wrap, $scope) {
		super($injector);

		// 		this.text = `<p>
		// 	En <knode kid="K_NODE;0000005M2U19ML5K08"></knode>,
		// 	les <knode kid="K_NODE;PERSON"></knode> ne peuvent pas être crées manuellement.
		// 	Il y a besoin du compte <knode kid="K_NODE;PERS_HERVE"></knode>
		// 	avec le role <knode kid="K_NODE;KR_ADMIN_SUPER"></knode>
		// </p>
		//
		// <pre><code class="language-js">const <span class="hljs-attr">a</span> =
		// <span class="hljs-number">2</span><span class="hljs-comment">;</span></code></pre>
		//
		// <p>
		// 	Fichier: <kdocument kid="K_NODE;0000005M8D0ZEFJG05"></kdocument>
		// </p>`;

		this.text = '';

		this.data = ref('');

		this.$sce = $sce;
		this.$wrap = $wrap;
		this.$scope = $scope;

		this.intervalNg = 0;
		this.intervalVue = ref(0);

		this.a = ref('aaa');

		this.b = computed(() => this.a.value.toUpperCase());

		/** @type {import('@vue/reactivity').Ref<string[]>} */
		this.array = ref([]);
		/** @type {string[]} */
		this.array2 = [];

		/** @type {import('@vue/reactivity').Ref<Map<string, string>>} */
		this.map = ref(new Map());
		this.map2 = new Map();

		this.mapped = computed(() => [...this.map.value]);
		this.mapped2 = new Map();
		this.$scope.$watch(() => this.map2, () => {
			this.mapped2 = this.map2;
		});

		this.context = reactive({
			counter: 0,
			counter2: 0,
		});

		this.$onInit();
	}

	increment() {
		this.context.counter += 1;
	}

	decrement() {
		this.context.counter -= 1;
	}

	/**
	 * @param {string} string
	 * @returns {any}
	 */
	trustAsHtml(string) {
		return this.$sce.trustAsHtml(string);
	}

	sleep(/** @type {number} */ ms) {
		return this.$wrap(() => new Promise(resolve => setTimeout(resolve, ms)));
	}

	getData() {
		return this.$wrap(async () => {
			await this.sleep(2000);

			return 'OK';
		});
	}

	async $onInit() {
		// eslint-disable-next-line angular/interval-service
		setInterval(async () => {
			await this.sleep(500);
			this.intervalNg += 1;
			this.intervalVue.value += 1;
		}, 1500);

		this.data.value = await this.getData();

		await this.sleep(500);
		this.array.value.push('coucou');
		this.array2.push('coucou');
		await this.sleep(500);
		this.array.value.push('hello');
		this.array2.push('hello');
		await this.sleep(500);
		this.array.value.push('hey');
		this.array2.push('hey');

		await this.sleep(500);
		this.map.value.set('a', 'coucou');
		this.map2.set('a', 'coucou');
		await this.sleep(500);
		this.map.value.set('b', 'hello');
		this.map2.set('b', 'hello');
		await this.sleep(500);
		this.map.value.set('c', 'hey');
		this.map2.set('c', 'hey');
	}
}
